/**
 * Template for creating new exercises
 */
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import NextIcon from '@material-ui/icons/SkipNext';
import PrevIcon from '@material-ui/icons/SkipPrevious';
import IconButton from '@material-ui/core/IconButton';
import SpeakerButton from '@material-ui/icons/VolumeUp';
import Button from '@material-ui/core/Button';
import { img, staticsUrl } from '../../config';

const useStyles = makeStyles(theme => ({
  grammar: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      maxHeight: '100%',
      background: '#fff',
      padding: '0 20px 20px',
      boxSizing: 'border-box',
      overflow: 'auto',
    },
  },
  exercise: {
    '& button': {
      cursor: 'pointer',
    },
    '& h3': {
      textAlign: 'center',
      marginBottom: '0.5em',
    },
    '& p': {
      textAlign: 'center',
      marginTop: 0,
    },
  },
  intro: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    width: 600,
    maxWidth: '100%',
    margin: '0 auto',
    '& > div': {
      overflow: 'auto',
      margin: '20px 0',
      width: '100%',
      textAlign: 'center',
    },
    '& p': {
      lineHeight: 1,
      margin: '0 0 3px',
    },
  },
  introTitle: {
    maxWidth: '100%',
    textAlign: 'center',
    borderRadius: 5,
    marginBottom: 5,
    padding: 5,
    lineHeight: 1,
    '& p': {
      fontSize: '20px !important',
    },
    '& span': {
      fontSize: '20px !important',
    },
  },
  introAction: {
    textAlign: 'center',
    '& button': {
      margin: '0 1px',
    },
    '& > div': {
      display: 'inline-block',
      padding: '0.25em 1em',
      color: '#a1008f',
      verticalAlign: 'middle',
      margin: '0 1px',
      borderRadius: 3,
    },
  },
  introBody: {
    marginBottom: 20,
    display: 'inline-block',
    textAlign: 'center',
    maxWidth: '100%',
    background: '#fff',
    userSelect: 'none',
    minWidth: 200,
    minHeight: 100,
  },
  imgWrap: {
    maxWidth: '100%',
    overflow: 'auto',
    '& > img': {
      marginBottom: 20,
      maxWidth: 'none',
    },
  },
  action: {
    textAlign: 'center',
    marginTop: 20,
  },
  textSpeach: {
    background: '#eee',
    padding: '0 20px',
    borderRadius: 5,
  },
}));

let timeout1 = 0;
let timeout2 = 0;

function Grammar(props) {
  const classes = useStyles();
  const [ exerciseArr, setExerciseArr ] = useState(false);
  const [ no, setNo ] = useState(0);
  const { exercise, startStats, finishExercise, action, type } = props.exerciseProps;

  useEffect(() => {
    startStats(type);
    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setExerciseArr(processData(exercise));
  }, [exercise]);

  const play = (url) => {
    action();
    props.media.play(staticsUrl + url);
  }

   const drawIntro = () => {
    const data = exerciseArr;
    const pages = data.elements[no];
    const len = data.elements.length;
    const next = () => {
      if (no < len - 1) setNo(no + 1);
      if (no === len - 2) finishExercise();
      action();
    }
    const prev = () => {
      if (no > 0) setNo(no - 1);
      action();
    }

    return (
      <div className={classes.intro}>
        <div>
          <div className={classes.introTitle} dangerouslySetInnerHTML={{__html: data.title}} />
          <div className={classes.introBody}>
            {pages.map(drawElement)}
          </div>
          <div className={classes.introAction}>
            <Button variant="outlined" color="secondary" onClick={prev} disabled={no === 0}><PrevIcon /></Button>
            <div>{no + 1}/{len} </div>
            <Button variant="outlined" color="secondary" onClick={next} disabled={no === len - 1}><NextIcon /></Button>
          </div>
        </div>
      </div>
    );
  }

  const drawElement = (el) => {
    switch(el.type) {
      case 'IMAGE':
        const imgUrl = `${staticsUrl + el.imageUrl}`;
        return <div key={el.imageUrl} className={classes.imgWrap}><img src={imgUrl} alt=""/></div>
      case 'MODEL':
        const soundUrl = `${staticsUrl + el.soundUrl}`;
        return (
          <div className={classes.textSpeach} key={el.soundUrl}>
            {el.text}
            <IconButton className={classes.qIcon} onClick={() => play(soundUrl)}>
              <SpeakerButton />
            </IconButton>
          </div>
        );
      default:
        console.log('unknown element', el);
    }
  }

  if (!exerciseArr) return '';

  return (
    <div className={classes.grammar}>
      <div>
        {drawIntro()}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { 
    media: state.media,
    mobile: state.mobile,
  }
}

function processData(exercise) {
  const elements = [];
  let elementData = [];
  exercise.elements.forEach(element => {
    if (element.type === 'NEW_PAGE') {
      elements.push(elementData);
      elementData = [];
    } else {
      elementData.push(element);
    }
  });
  if (elementData.length > 0) elements.push(elementData);
  return { ...exercise, elements }
}

export default connect(mapStateToProps)(Grammar);